import React from 'react';
import { hasPackageChoice } from '../../data/adaOrderRules';
import SectionFive from '../pageSections/SectionFive';
import SectionFour from '../pageSections/SectionFour';
import SectionOne from '../pageSections/SectionOne';
import SectionSeven from '../pageSections/SectionSeven';
import SectionSix from '../pageSections/SectionSix';
import SectionThree from '../pageSections/SectionThree';
import SectionTwo from '../pageSections/SectionTwo';

const FormContent = ({
	control,
	register,
	handleChange,
	formData,
	setValue,
	getValues,
	setSelectedServices,
	preselectedLocation,
	sending,
}) => {
	const packageChosen = hasPackageChoice(formData.packageChoice);

	return (
		<div className='form-content'>
			<SectionOne
				control={control}
				register={register}
				formData={formData}
				setValue={setValue}
				handleChange={handleChange}
				preselectedLocation={preselectedLocation}
			/>

			<div
				style={{
					height: '1px',
					backgroundColor: '#00000050',
					margin: '40px 0',
					width: '100%',
				}}
			></div>

			<SectionTwo
				register={register}
				formData={formData}
				setValue={setValue}
				setSelectedServices={setSelectedServices}
			/>

			{packageChosen && (
				<>
					<div
						style={{
							height: '1px',
							backgroundColor: '#00000050',
							margin: '40px 0',
							width: '100%',
						}}
					></div>

					<SectionThree
						register={register}
						formData={formData}
						handleChange={handleChange}
					/>

					<div
						style={{
							height: '1px',
							backgroundColor: '#00000050',
							margin: '40px 0',
							width: '100%',
						}}
					></div>

					<SectionFour
						register={register}
						formData={formData}
						handleChange={handleChange}
					/>

					<div
						style={{
							height: '1px',
							backgroundColor: '#00000050',
							margin: '40px 0',
							width: '100%',
						}}
					></div>

					<SectionFive
						setValue={setValue}
						register={register}
						formData={formData}
						control={control}
					/>

					<div
						style={{
							height: '1px',
							backgroundColor: '#00000050',
							margin: '40px 0',
							width: '100%',
						}}
					></div>

					<SectionSix
						register={register}
						setValue={setValue}
						getValues={getValues}
					/>

					<div
						style={{
							height: '1px',
							backgroundColor: '#00000050',
							margin: '40px 0',
							width: '100%',
						}}
					></div>

					<SectionSeven
						register={register}
						formData={formData}
						sending={sending}
					/>
				</>
			)}
		</div>
	);
};

export default FormContent;
